import React from 'react'
import TransfiNITTe from '../components/Transfinitte'
import Footer from '../components/footer'
export default function Transfinitte() {
  return (
    <div>
      <TransfiNITTe />
      <Footer />
    </div>
  )
}
